import TextField from "../../components/fields/textField/TextField.vue";
import SelectField from "../../components/fields/selectField/SelectField.vue";
import AutocompleteField from "../../components/fields/autocompleteField/AutocompleteField.vue";
import PeriodoField from "../../components/fields/periodoField/PeriodoField.vue";
import AlterarPeriodo from "./alterar-periodo/AlterarPeriodo.vue";
import AjustarFerias from "./ajustar-ferias/AjustarFerias.vue";
import AnalisarAlteracao from "./analisar-alteracao/AnalisarAlteracao.vue";
import AnalisarFerias from "./analisar-ferias/AnalisarFerias.vue";
import SubstituicaoServidorFerias from "./substituicao-servidor-ferias/SubstituicaoServidorFerias.vue";
import SolicitarFerias from "./solicitar-ferias/SolicitarFerias.vue";
import SolicitarFerias30Anos from "./solicitar-ferias-30-anos/SolicitarFerias30Anos.vue";
import DefinirFeriasEscolares from "./definir-ferias-escolares/DefinirFeriasEscolares.vue";
import FeriasVantagem from "./ferias-vantagem/FeriasVantagem.vue";
import FeriasProrrogada from "./ferias-prorrogadas/FeriasProrrogadas.vue";
import SolicitarFeriasPremio from "./ferias-premio/FeriasPremio.vue";
import AnalisarCassacao from "./analisar-cassacao/analisarCassacao.vue";
import AprovarFeriasLote from "./aprovar-ferias-lote/AprovarFeriasLote.vue";
import CassarFerias from "./cassar-ferias/CassarFerias.vue";
import AgendarFerias from "./agendar-ferias/AgendarFerias.vue";
import ParametrizarExclusao from "./parametrizar-exclusao/ParametrizarExclusao.vue";
import ConfirmDialog from "../../components/dialog/confirm/ConfirmDialog.vue";
import OkayDialog from "../../components/dialog/okay/OkayDialog.vue"
import OkayCustomAbonoPagar from "../../components/dialog/okayCustom/OkayCustom.vue"
import MilitaresFeriasAVencer from "../calendario-ferias/menssagem/militares-ferias-a-vencer/MilitaresFeriasAVencer.vue"
import MilitaresNaoAgendado from "../calendario-ferias/menssagem/militares-nao-agendados/MilitaresNaoAgendado.vue"
import EmitirRelatorio from "./emitir-relatorio/EmitirRelatorio.vue";

import { FeriasService } from "../../services/FeriasService";
import { ExcluirFeriasService } from "../../services/ExcluirFeriasService";
import { MensagensService } from "../../services/MensagensService";
import { RelatorioService } from "../../services/RelatorioService";
import { FUNCIONALIDADES } from "../../constants";
import moment from "moment";
import { tipoPerfil } from "../../constants";
import { date } from "date-typescript-library";
import PerfilService from "@/services/PerfilService";
import { numeroBmMixin } from "../../mixins/numeroBmMixin";
import { calcularSeDataFinalEhAnteriorAHoje } from "../../helper/helper";

export default {
  name: "CalendarioFerias",

  components: {
    TextField,
    SelectField,
    AutocompleteField,
    PeriodoField,
    AlterarPeriodo,
    AjustarFerias,
    AnalisarAlteracao,
    AnalisarFerias,
    SolicitarFerias,
    FeriasVantagem,
    FeriasProrrogada,
    SolicitarFeriasPremio,
    SubstituicaoServidorFerias,
    ParametrizarExclusao,
    AnalisarCassacao,
    CassarFerias,
    AgendarFerias,
    AprovarFeriasLote,
    ConfirmDialog,
    OkayDialog,
    MilitaresFeriasAVencer,
    MilitaresNaoAgendado,
    EmitirRelatorio,
    SolicitarFerias30Anos,
    DefinirFeriasEscolares,
    OkayCustomAbonoPagar,
  },

  mixins:[numeroBmMixin],

  data: () => ({
    sortBy: '',
    sortDesc: false,
    headers: [
      { text: "Nº BM", value: "numero", width: "10%", disableSort: true },
      { text: "Posto/Graduação", value: "graduacao", width: "150px", disableSort: true },
      { text: "Nome", value: "nome", width: "120px", disableSort: true },
      { text: "Unidade", value: "unidade", width: "150px", disableSort: true },
      { text: "Lotação", value: "lotacao", width: "150px", disableSort: true },
      { text: "Exercício", value: "exercicio", width: "110px", disableSort: true },
      { text: "Período de Férias", value: "periodo", sortable: false, },
      { text: "Dias de Férias", value: "diasFerias", width: "110px", disableSort: true },
      { text: "Dias Restantes", value: "diasRestantes", width: "110px", disableSort: true },
      { text: "Parcela", value: "parcela", width: "110px", disableSort: true },
      { text: "Substituto", value: "substituto", width: "110px", disableSort: true },
      { text: "Abono", value: "status_abono", width: "110px", disableSort: true },
      { text: "Tipo Ferias", value: "tipo", width: "110px", disableSort: true },
      { text: "Status", value: "status", width: "110px", disableSort: true },
      { text: "Ações", value: "actions", sortable: false, align: "center" },
      { text: "Excluir Férias", value: "exclui", sortable: false, align: "center" },
    ],
    perfil:[],
    items: [],
    page: 1,
    pageCount: 0,
    totalItems: 0,
    
    moda:null,
    permissaoSolicitarFerias: false,

    selected: [],
    selectedAction: {},
    singleSelect: false,
    idSelected: null,
    statusSelected: "",
    periodoSelected: "",
    numeroDiasSelected: "",
    menssagens:[],

    unidade: [],
    filter: {},

    optionsFilter: {
      postoGraduacao: [],
      status: [],
      unidade: [],
      lotacao: [],
      exercicio: [],
      exercicioPesquisar:[],
      perfil:[],
    },
    tmp_perfil:[],
    actionsDialog: false,
    alterarPeriodoDialog: false,
    ajustarFeriasDialog: false,
    analisarAlteracaoDialog: false,
    analisarFeriasDialog: false,
    substituicaoServidorDialog: false,
    solicitarFeriasDialog: false,
    definirFeriasDialog: false,
    FeriasVantagemDialog: false,
    FeriasProrrogadaDialog: false,
    solicitarFeriasPremioDialog: false,
    solicitarFerias30AnosDialog: false,
    parametrizarExclusaoDialog: false,
    analisarCassacaoDialog: false,
    cassarFeriasDialog: false,
    AgendarFeriasDialog: false,
    aprovarFeriasLoteDialog: false,
    confirmDialog: false,
    OkayDialog: false,
    MilitaresFeriasAVencerDialog:false,
    MilitaresNaoAgendadoDialog:false,
    EmitirRelatorioDialog: false,
    disabledLotacao: true,
    perfil_selected:'...',
    paginacao:[],
    loading: {
      table: false,
      btn: false,
      field: false,
    },
    OkayDialogEmissaoRelatoriosAbonoPagar: false,
  }),

  beforeMount() {
    this.validarParametrizacao()
    this.initModa()
    this.initializeFilter();
    },

  async mounted() {

    this.validarParametrizacao()
    this.getPermissaoSolicitarFerias();
    this.getMenssagens();
    this.getMenssagensRelatorioParaChefeSeplanAbonoPagar();
    this.setPerfilList();
    this.getFerias();
    this.getFerias();

    this.getGraduacaoItems();
    this.getUnidadeItems();
    this.getLotacaoItems();
    this.getExercicioItems();
    this.getExercicioPesquisar();
    this.getStatusItems();
    this.getPerfilItems();
    this.getFuncionalidesPorPerfil();
    this.MilitaresFeriasAVencerDialog = this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1;
    this.MilitaresNaoAgendadoDialog = this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1;

  },

  computed: {
    mapItems() {

      return this.items.map((x) => ({
        ...x,
        isSelectable: x.status.slice(0, 10) == "Em Análise",
      }));
    },
    funcionalidadesEnum() {
      return FUNCIONALIDADES;
    },
  },

  watch: {

    page: async function(val) {
      this.page = val;
      await this.getFerias();
    },
    'unidade': function(unidade) {
      if (unidade) {
        this.getLotacoesItems(unidade);
        this.disabledLotacao = false;
      } else {
        this.disabledLotacao = true;
        this.unidade = null;
        this.filter.lotacao = null;
      }
    }
  },
  methods: {
    updateOptions(options) {
      this.sortBy = options.sortBy;
      this.sortDesc = options.sortDesc[0];
      this.getFerias();
    },
    async getLotacoesItems(unidade) {
      this.loading.field = true;
      const response = await FeriasService.getLotacaoByUnidade(unidade);
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.loading.field = false;
    }, 
    async initModa() {
      this.moda = localStorage.perfil_id;
      this.$store.state.perfil_id = localStorage.perfil_id;
    },
    setDefaultPerfil(tmp) {
      const tmp_count = [];

      Object.keys(tmp).map(function(key) {

        if(tmp[key].hierarquia != 10) {
          tmp_count[key] = tmp[key];
        }

      });

      tmp_count.sort((a,b) => a.hierarquia > b.hierarquia ? 1: -1)
      localStorage.perfil_id = tmp_count[0].id;
      this.$store.state.perfil_id = tmp_count[0].id;
      localStorage.perfil_label = tmp_count[0].nome;
      localStorage.perfil_hir = tmp_count[0].hierarquia;
    },
    initializeFilter() {
      this.filter = {
        dataInicio: null,
        dataFim: null,
      };
    },

    async getFuncionalidesPorPerfil(){
      const response = await PerfilService.getFuncionaliadesByPerfilId(this.$store.state.perfil_id);

      this.$store.state.funcionalidades_perfil = response;
    },

    verificarSePerfilSetadoTemPermissao(funcionalidade_id){
      const permissao = this.$store.state.funcionalidades_perfil.find((value) => {
        return value.id == funcionalidade_id;
      });

      return !!permissao;
    },

    async getMenssagens(){
      const response = await MensagensService.getMensagens();
      if(response){
        this.OkayDialog = true;
      }

    },

    async getMenssagensRelatorioParaChefeSeplanAbonoPagar() {

      let verificarChefeSeplan = this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');

      if (verificarChefeSeplan) {

        let response = await RelatorioService.getMensagensAbonoPagar();

        if (response) {
          this.OkayDialogEmissaoRelatoriosAbonoPagar = true;
        }
      }
    },

    async downloadAbonoPagar() {
      await RelatorioService.downloadAbonoPagar();
    },

    async getFerias() {
      const filter = this.prepareFormFilter()
      const p = await FeriasService.obterFerias(filter);
      if(typeof p !== 'string') {
        this.items = p.data;
        this.paginacao = p;
        this.pageCount = p.last_page;
        this.totalItems = p.total;
        this.loading.table = false;
        this.$forceUpdate();
      }
      
    },

    async pesquisarFerias(){
      this.$forceUpdate();
      await this.getFerias();
      this.pageCount = this.paginacao.last_page;
 


    },
    async _getFerias() {

      this.loading.table = true;
      const filter = this.prepareFormFilter();
  
     await FeriasService.getFerias(filter).then((response) => {
         if(typeof response == 'object') {
           this.items = response.data;
           this.pageCount = response.last_page;
           this.totalItems = response.total;
           this.loading.table = false;
           this.$forceUpdate();
         }
       })
    },

    prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);
      filter.append("perfil_current", this.$store.state.perfil_id)

      if (this.filter.numeroBM) {
        const numeroBM = this.filter.numeroBM.replace(".", "");
        const [numero, digitoVerificador] = numeroBM.split("-");
        filter.append("numero", this.removerZero(numero));
        if (digitoVerificador != undefined) filter.append("digito_verificador", digitoVerificador);
      }

      this.filter.nomeUsuario
        ? filter.append("nome", this.filter.nomeUsuario)
        : null;

        if (Array.isArray(this.filter.postoGraduacao) && this.filter.postoGraduacao.length > 0) {
          const validStatus = this.filter.postoGraduacao.filter(s => s !== null && s !== '');
          if (validStatus.length > 0) {
            filter.append("id_graduacao", validStatus.join(','));
          }
        }

        if (Array.isArray(this.filter.status) && this.filter.status.length > 0) {
          const validStatus = this.filter.status.filter(s => s !== null && s !== '');
          if (validStatus.length > 0) {
            filter.append("status", validStatus.join(','));
          }
        }
        
      this.filter.dataInicio
        ? filter.append(
            "data_ini",
            moment(this.filter.dataInicio).format("YYYY-MM-DD")
          )
        : null;
      this.filter.dataFim
        ? filter.append(
            "data_fin",
            moment(this.filter.dataFim).format("YYYY-MM-DD")
          )
        : null;
      this.unidade
        ? filter.append("id_unidade", this.unidade)
        : null;
        this.filter.lotacao
        ? filter.append("id_lotacao", this.filter.lotacao)
        : null;


        if (Array.isArray(this.filter.exercicio) && this.filter.exercicio.length > 0) {
          const validStatus = this.filter.exercicio.filter(s => s !== null && s !== '');
          if (validStatus.length > 0) {
              filter.append("exercicio", validStatus.join(','));
          }
      }

      this.filter.perfil
        ? filter.append('id_perfil',this.filter.perfil)
        : null;

        if (this.sortBy) {
          filter.append("sort_by", this.sortBy);
          filter.append("sort_desc", this.sortDesc ? 'desc' : 'asc');
        }

      return filter;
    },

    async validarParametrizacao(){
     await FeriasService.validarParametrizacao();
    
    },

    async getGraduacaoItems() {
      this.loading.field = true;
      const response = await FeriasService.getGraduacao();
      this.optionsFilter.postoGraduacao = response.map((el) => {
        return {
          text: el.descricao,
          value: el.id,
        };
      });
      this.optionsFilter.postoGraduacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

   async getUnidadeItems() {
      this.loading.field = true;
      const response = await FeriasService.getUnidade();
      this.optionsFilter.unidade = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidade?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    }, 

    async getLotacaoItems() {
      this.loading.field = true;
      const response = await FeriasService.getLotacao();
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.lotacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

    async getExercicioItems() {
      this.loading.field = true;
      const postData = new FormData();
      postData.append('id_tipo', null)
      const response = await FeriasService.getExercicio();
      this.optionsFilter.exercicio = response.map((el) => {
        return {
          text: el.ano,
          value: el.ano,
        };
      });
      this.optionsFilter.exercicio?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },
    async getExercicioPesquisar() {
      this.loading.field = true;
      const response = await FeriasService.getExerciciosPesquisar();
      this.optionsFilter.exercicioPesquisar = response.map((el) => {
        return {
          text: el.ano,
          value: el.ano,
        };
      });
      this.optionsFilter.exercicioPesquisar?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },

    async getStatusItems() {
      this.loading.field = true;
      const response = await FeriasService.getStatus();
      this.optionsFilter.status = response.map((el) => {
        return {
          text: el.tipo_status,
          value: el.id,
        };
      });
      this.optionsFilter.status?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },

    async getPermissaoSolicitarFerias(){
      this.permissaoSolicitarFerias  = await FeriasService.getValidacaoSolicitacao();
    },

    async setPerfilList() {
      this.perfil = tipoPerfil;
    },
    async changePerfilMenu(event) {

      let tmp_set_ev = 0;
      if(event == 0) {
        localStorage.removeItem('perfil_id');
        localStorage.removeItem('perfil_label');
        localStorage.removeItem('perfil_hir');
      }
      this.tmp_perfil.forEach(function(data) {

        if(data.id == event) {
          //this.moda = data.id;
         // console.log('data -> ',data)
          tmp_set_ev = data.hierarquia;
          //this.perfil_selected = data.nome;
         // console.log(this.perfil_selected)

          localStorage.perfil_id = event;
          localStorage.perfil_label = data.nome;
        }
      })
      if(event !== localStorage.perfil_hir && event !== undefined) {
        localStorage.perfil_hir = tmp_set_ev;
       this.$router.go(this.$router.currentRoute);
      }

      this.$store.state.perfil_id = event;
      this.$store.state.perfil_hir = tmp_set_ev;

     // this.$router.go(this.$router.currentRoute);
    },
    async getPerfilItems() {
      this.loading.field = true;
      const tmp_per = [
        {
          nome:'Solicitante',
          id:2,
          hierarquia:0,
          descricao:'Solicitante'
        }
      ];
      await PerfilService.getPerfisSelect().then((response) => {
        if(response.length == 0) {
          this.tmp_perfil = tmp_per;
          this.optionsFilter.perfil = tmp_per.map((el) => {

            return {
              text: el.nome,
              value: el.id,
            };
          });
          if(!localStorage.perfil_id) {
            this.setDefaultPerfil(tmp_per)
          }
          this.$store.state.perfil_label = this.tmp_perfil.find(obj => {
            if(obj.id == this.moda) {
              return obj.nome;
            }
          });
          this.perfil_selected = localStorage.perfil_label;
          //this.optionsFilter.perfil?.unshift({ text: "Selecione", value: "0" });
        } else {
          this.tmp_perfil = response;
          this.optionsFilter.perfil = response.map((el) => {

            return {
              text: el.nome,
              value: el.id,
            };
          });
          if(!localStorage.perfil_id) {
            this.setDefaultPerfil(response)
          }
          this.$store.state.perfil_label = this.tmp_perfil.find(obj => {
            if(obj.id == this.moda) {
              return obj.nome;
            }
          });
          this.perfil_selected = localStorage.perfil_label;
          //this.optionsFilter.perfil?.unshift({ text: "Selecione", value: "0" });
        }



      })
      /*
      this.tmp_perfil = response;
     // console.log(response);
      this.optionsFilter.perfil = response.map((el) => {

        return {
          text: el.nome,
          value: el.id,
        };
      });

      console.log(this.optionsFilter.perfil)

      this.$store.state.perfil_label = this.tmp_perfil.find(obj => {
        if(obj.id == this.moda) {
          return obj.nome;
        }
      });
      this.perfil_selected = this.tmp_perfil.find(obj => {
        console.log(this.moda)
        if(obj.id == this.moda) {
          console.log(obj)
          return obj.nome;
        }
      });
      this.moda = localStorage.perfil_id;
      this.optionsFilter.perfil?.unshift({ text: "Selecione", value: "" });
     // this.optionsFilter.perfil?.unshift({ text: "Selecione", value: "" });
      //console.log(this.optionsFilter.perfil);
      */

      this.loading.field = false;
    },

    openActionsDialog(item) {
      this.actionsDialog = true;
      this.idSelected = item.idFerias;
      this.periodoSelected = item.periodo;
      this.numeroDiasSelected = item.diasFerias;
      this.statusSelected = item.status;
      this.selectedAction = {
        idTipo: item.idTipo ? item.idTipo : "",
        idPerfil: item.id_perfil? item.id_perfil: "",
        idSigrh: item.idSigrh? item.idSigrh : "",
        idFerias: item.idFerias? item.idFerias : "",
        idUnidade: item.idUnidade? item.idUnidade : "",
        exercicio: item.exercicio,
        nBM: item.numero ? item.numero : "",
        posto: item.graduacao ? item.graduacao : "",
        nome: item.nome ? item.nome : "",
        periodoAlterado: item.periodoAlterado ? item.periodoAlterado : "",
        numeroDias: item.diasFerias ? item.diasFerias : "",
        dataIni: item.dataIni ? item.dataIni : "",
        dataFin: item.dataFin ? item.dataFin : "",
        IdStatus: item.IdStatus? item.IdStatus: "",
        diasRestantes: item.diasRestantes? item.diasRestantes: "",


      };

    },

    openDeleteDialog(item) {
      this.idSelected = item.idFerias;
      this.confirmDialog = true;

    },

    async fecharDialogAbonoPagar() {
      const response = RelatorioService.removerAlerta()
      if (response) {
        this.OkayCustomAbonoPagar = false;
      }
    },

    async lerMenssagem(id, index){
      const response = MensagensService.lerMenssagem(id)
      if(response){
        this.menssagens.splice(index, 1);
      }
      if(this.menssagens.length == 1){
        this.OkayDialog = false;
      }
    },

    async verificarMilitaresSemAgendamentoFerias() {
      const response = MensagensService.verificarMensagemChefeSeplanMilitaresSemAgendamento()
      this.MilitaresNaoAgendadoDialog = response.data;
    },

    trocarHistoricoFerias(){
      this.$router.push({ name: 'HistoricoFerias', params:{ferias: this.selectedAction} })
    },

    verificarPermisao(){
      const permissao = this.verificarSePerfilTemPermissao('SOLICITANTE') && this.$store.state.user.Perfis.length == 1? true : false
      return permissao
    },

    verificarPermissaoAprovarFeriasVantagem(){
      return !this.verificarPermisao() || this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.APROVAR_FERIAS_PARA_VANTAGEM)
    },

    verificarExcluirFerias(parametrizarExclusao){
      const verificarChefeSeplan = this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');
      const verificarUnidadeApoiadora = this.verificarSePerfilTemPermissao('UNIDADE_APOIADORA');
      const verificarGerenteDHR = this.verificarSePerfilTemPermissao('GERENCIA');
      const verificarAdmin = this.verificarSePerfilTemPermissao('ADMINISTRADOR_SISTEMA');
    
      if(verificarAdmin){
        console.log('verificarAdmin', verificarAdmin)
        return verificarAdmin;
      }

      if(verificarGerenteDHR){
        console.log('verificarGerenteDHR', verificarGerenteDHR)
        return verificarGerenteDHR;
      }

      if(this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.EXCLUIR_FERIAS)){
        console.log('this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.EXCLUIR_FERIAS)', this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.EXCLUIR_FERIAS))
        return true;
      }

      console.log('verificarChefeSeplan', verificarChefeSeplan)
      console.log('verificarUnidadeApoiadora', verificarUnidadeApoiadora)
      console.log('parametrizarExclusao', parametrizarExclusao)

      return (verificarChefeSeplan || verificarUnidadeApoiadora ) && parametrizarExclusao == 1 ;
    },

    verificarPermisaoBoletim(){
      const verificarChefeSeplan = this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');
      const verificarUnidadeApoiadora = this.verificarSePerfilTemPermissao('UNIDADE_APOIADORA');
      const verificarGerenteDHR = this.verificarSePerfilTemPermissao('GERENCIA');
      const permissao = verificarChefeSeplan || verificarUnidadeApoiadora || verificarGerenteDHR
            
      return permissao || this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.ATOS_E_BOLETIM)
    },

    verificarParametrizarExclusao(){
      return this.verificarSePerfilTemPermissao('GERENCIA');
    },

    verificarPermissaoAjustarFerias(tipo){

      if(tipo === 3){
        return false;
      }

      return this.verificarSeUsuarioEstaMexendoNasPropriasFerias() || (!this.verificarSeUsuarioEstaMexendoNasPropriasFerias() && this.verificarSePerfilTemPermissao('CHEFE_SEPLAN'));
    },

    verificarSeUsuarioEstaMexendoNasPropriasFerias(){
      return this.$store.state.user.idSigrh == this.selectedAction.idSigrh;
    },

    verificarPermisaoAnalisar(){

      if(this.verificarSeUsuarioEstaMexendoNasPropriasFerias()){
        return true;      
      }

      let verificar = true;

      const statusPerfil = [
        {perfil:'CHEFE_DIRETO', status: 'Em Análise do Chefe Direto'},
        {perfil:'CHEFE_SEPLAN', status: 'Em Análise do Chefe SEPLAN (Ou Similares)'},
        {perfil:'COMANDANTE_COMPANHIA', status: 'Em Análise do Comandante da Companhia Operacional'},
        {perfil:'COMANDANTE', status: 'Em Análise do Comandante (Ou Similares)'},
        {perfil:'COMANDANTE', status: 'Em Análise do Comandante (Ou Similares)'},
        {perfil:'GERENCIA', status: 'Em Análise da Gerência - DRH'},
      ]

      statusPerfil.forEach((value) => {        
        if(this.verificarSePerfilPodeAcessarFuncao(value.perfil, value.status, this.statusSelected)){
          verificar = false;
        }
      });

      if(this.selectedAction.IdStatus == 20){
        if(this.verificarSePerfilTemPermissao('COMANDANTE')){
          verificar = false;
        }
      }

      
      return verificar;
    },

    verificarAprovarLote(status){
      let verificar = true;
  
      const statusPerfil = [
        {perfil:'CHEFE_DIRETO', status: 'Em Análise do Chefe Direto'},
        {perfil:'COMANDANTE_COMPANHIA', status: 'Em Análise do Comandante da Companhia Operacional'},
        {perfil:'COMANDANTE', status: 'Em Análise do Comandante (Ou Similares)'},
        {perfil:'CHEFE_SEPLAN', status: 'Em Análise do Chefe SEPLAN (Ou Similares)'},
      ]

      statusPerfil.forEach((value) => {
        if(this.verificarSePerfilPodeAcessarFuncao(value.perfil, value.status, status)){
          verificar = false;
        }
      });
     
      if(this.selectedAction.IdStatus == 20){
        if(this.verificarSePerfilTemPermissao('COMANDANTE')){
          verificar = false;
        }
      }
  
      return verificar;
    },

    verificarPermissaoFerias30Anos(){
      return true;
    },

    verificarPermisaoAnalisarCassacao(){

      if(this.verificarSeUsuarioEstaMexendoNasPropriasFerias()){
        return true;
      }

      let verificar = true;

      const statusPerfil = [
        {perfil:'CHEFE_DIRETO', status: 'Cassação em Análise do Chefe Direto'},
        {perfil:'COMANDANTE_COMPANHIA', status: 'Cassação em Análise do Comandante da Companhia Operacional'},
        {perfil:'COMANDANTE', status: 'Cassação em Análise do Comandante (Ou Similares)'},
        {perfil:'CHEFE_SEPLAN', status: 'Cassação em Análise do Chefe SEPLAN (Ou Similares)'},
      ]

      statusPerfil.forEach((value) => {
        if(this.verificarSePerfilPodeAcessarFuncao(value.perfil, value.status, this.statusSelected)){
          verificar = false;
        }
      });

      if(!verificar && this.selectedAction.idPerfil == tipoPerfil['SOLICITANTE']){
        verificar = false;
      }
 
      return verificar;
    },

    verificarSePerfilPodeAcessarFuncao(perfil, status_ferias, status_para_verificar){ 
      return this.verificarSePerfilTemPermissao(perfil) && status_para_verificar == status_ferias;
    },

    verificarAgendarFerias(){
      const funcionalidadeDisponivel = this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.AGENDAR_FERIAS)

      return this.verificarSePerfilTemPermissao('CHEFE_SEPLAN') || funcionalidadeDisponivel;
    },

    verificarSubstituicaoServidorFerias() {
      const now = moment();
      const dataFim = moment(this.selectedAction.dataFin);
  
      if (dataFim.isBefore(now, 'day')) {
        return false;
      }

      if (this.verificarSeUsuarioEstaMexendoNasPropriasFerias()) {
        return false;
      }

      return this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');
    },

    verificarFeriasProrrogadas(){
      const funcionalidadeDisponivel = this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.FERIAS_PRORROGADAS_INTERROMPIDAS);
      const perfilPermetidoVisualizar = this.verificarSePerfilTemPermissao('CHEFE_SEPLAN') || this.verificarSePerfilTemPermissao('UNIDADE_APOIADORA')

      return funcionalidadeDisponivel || perfilPermetidoVisualizar;
    },

    verificarSePerfilTemPermissao(perfil){


      return this.$store.state.perfil_id == tipoPerfil[perfil];
    },

    verificarCassarFerias(){

      if(this.verificarSeUsuarioEstaMexendoNasPropriasFerias()){
        return false  
      }

      const verificarChefeDireto = this.verificarSePerfilTemPermissao('CHEFE_DIRETO');
      const verificarComandantesCompanhia = this.verificarSePerfilTemPermissao('COMANDANTE_COMPANHIA');
      const verificarChefeSeplan = this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');
           
      let verificacao = true;
      
      if(verificarChefeDireto){

        if(this.selectedAction.idPerfil  != tipoPerfil['SOLICITANTE']){
          verificacao =  false
        } 
      }
      if(verificarComandantesCompanhia){
        if(this.selectedAction.idPerfil  != tipoPerfil['CHEFE_DIRETO'] && this.selectedAction.idPerfil  != tipoPerfil['SOLICITANTE']){
          verificacao =  false;
        } 
      }
    
      if(verificarChefeSeplan){
        if(this.selectedAction.idPerfil  == tipoPerfil['COMANDANTE']){
          verificacao =  false;
        } 
      }

      if(!verificacao){
        return verificacao;
      }

      return this.verificarSePerfilTemPermissao('SOLICITANTE') && this.$store.state.user.Perfis.length == 1 ?
      false :  ( this.selectedAction.dataIni <= date("Y-m-d") && this.selectedAction.dataFin >= date("Y-m-d") )
    },


    verificarPermisaoAlterar() {

      if (this.verificarSeUsuarioEstaMexendoNasPropriasFerias()) {
        return true;
      }

      if (this.verificarSePerfilTemPermissao('CHEFE_SEPLAN') && calcularSeDataFinalEhAnteriorAHoje(this.selectedAction.dataFin)) {
        //libera para chefe seplan mesmo que as férias já tenham passado
        return false;
      }

      if (calcularSeDataFinalEhAnteriorAHoje(this.selectedAction.dataFin)) {
        return true;
      }

      return this.verificarSePerfilTemPermissao('SOLICITANTE') && this.$store.state.user.Perfis.length == 1
    },

    verificarHistoricoFerias(){
      return this.verificarSeUsuarioEstaMexendoNasPropriasFerias || this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');

    },

    async excluirFerias() {
      this.confirmDialog = false;
      await ExcluirFeriasService.excluirFerias(this.idSelected);
      this.getFerias();
    },

    closeActionsDialog() {
      this.actionsDialog = false;
      this.getFerias();
    },

    redirectCalendarioCivil () {
      this.$router.push("/calendario-civis");
    }
  },
};
